import { LinearProgress } from '@mui/material';

import { FullPageMessage } from '../FullPageMessage';

export const Loading = () => <LinearProgress />;
export const Authenticating = () => <LinearProgress />;

export const AuthenticatingError = () => (
	<FullPageMessage
		message="Authentication error"
		secondaryText="Please try again"
		state="error"
		showGoHome
	/>
);
export const SessionLost = () => (
	<FullPageMessage
		message="Session timed out"
		secondaryText="Your session has expired. Please log in again"
		showGoHome
	/>
);
export const ServiceWorkerNotSupported = () => (
	<FullPageMessage
		message="Unable to authenticate on this browser"
		secondaryText="Your browser is not secure enough to make authentication work. Try updating your browser or
				use a newer browser."
		state="error"
	/>
);
export const CallbackSuccess = () => (
	<FullPageMessage
		message="Log in successful"
		secondaryText="Loading MDDi"
		state="success"
	/>
);
